import { render, staticRenderFns } from "./CriarStakeholder.vue?vue&type=template&id=62f06764&scoped=true&"
import script from "./CriarStakeholder.vue?vue&type=script&lang=js&"
export * from "./CriarStakeholder.vue?vue&type=script&lang=js&"
import style0 from "./CriarStakeholder.vue?vue&type=style&index=0&id=62f06764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f06764",
  null
  
)

export default component.exports